import {userType} from "../context/filterContext";

const getInitials = (fullName: string) => fullName.split(' ').map((name)=>
    name.charAt(0).toUpperCase()).slice(0, 2).join('');

const captializeText = (text: string) =>
    text.charAt(0).toUpperCase() + text.slice(1);

const getFullNameById = (id: number, users: userType[]) => {
    const user = users.filter((user: any)=> user.id === id)[0];
    return `${user?.firstName} ${user?.lastName}`;
}

const formatDate = (date: string) => {
    const formattedData = new Date(date).toDateString();
    return formattedData;
}

const getDateInYYYYMMDD = (dateStr: string) => {
    const date = new Date(dateStr)
    const year = date.getFullYear();
    const month = date.getMonth()+1;
    const day = date.getDate()
    return `${year}-${month}-${day}`;
}

const checkNull = (input: any, value: 'string' | 'number') => {
    if (input === null || undefined) {
        return value === 'string'? '': 0;
    } else {
        return input;
    }
}

const convertNumberToSequence = (number: number) => {
    const countdown: number[] = [];
    for(let i=1; i<=number; i++) {
        countdown.push(i);
    }
    return countdown;
}

const convertDate = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString('en-US', {day: '2-digit', month: 'short', year:'numeric', hour:'2-digit', minute: '2-digit'});
};

const wholesalerBg = (type: string, distribution: string) => {
    if (type.toLowerCase() === 'wholesaler') {
        return true;
    } else {
        return false;
    }
}

const formatFileSize = (size: number) => {
    const kb = Math.round(size / 1000);
    if (kb > 1000) {
        return `${Math.round(kb / 1000)} MB`;
    } else {
        return `${kb} KB`;
    }
}

const getUserPermisson = (permission: string,
    query: 'A' | 'R' | 'C' | 'U'| 'D') => {
        if (permission.includes(query)) {
            return true;
        } else {
            return false;
        }
}

const getImageAspectRatio = (
    naturalWidth: number, naturalHeight: number
) : number => {
    return naturalHeight === 0 ?
    naturalWidth :
    getImageAspectRatio(naturalHeight, naturalWidth % naturalHeight);
}

export {getInitials, captializeText, getFullNameById, formatDate,
  checkNull, convertNumberToSequence, convertDate, wholesalerBg,
  formatFileSize, getImageAspectRatio, getUserPermisson, getDateInYYYYMMDD};
